import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DashboardService} from 'app/main/services/dashboard.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-recommended-actions-widget',
    templateUrl: './recommended-actions-widget.component.html',
    styleUrls: ['./recommended-actions-widget.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RecommendedActionsWidgetComponent implements OnInit, OnChanges {
    public data: any;
    public modalData: any;
    public isLoading: boolean = true;
    public modalLoading: boolean;
    public itemId: number;

    @Input() referencial: any;

    public labels = {
        difficulties: ['EASY', 'MEDIUM', 'HARD'],
        prices: ['€', '€€', '€€€'],
        importances: ['EASY', 'MEDIUM', 'HIGH'],
    };

    constructor(private modalService: NgbModal, private _dashboard: DashboardService, private _translateService: TranslateService) {
    }

    modalOpen(modalLG, id: number) {
        this.getModalData(id);
        this.modalService.open(modalLG, {size: 'lg'});
    }

    private getData() {
        this.isLoading = true;

        this._dashboard.postRecommendation(1, null, null, null, null, null, false).subscribe(
            (res: any) => {
                this.data = res.data;
                console.log(this.data);
                this.isLoading = false;
            },
            (err: any) => {
                console.error(err);
                this.isLoading = false;
            }
        );
    }

    private getModalData(id: number) {
        this.modalLoading = true;

        this._dashboard.getModal(id).subscribe(
            (res: any) => {
                this.modalData = res.data;
                this.modalLoading = false;
            },
            (err: any) => {
                console.error(err);
                this.modalLoading = false;
            }
        );
    }

    ngOnInit(): void {
        this.getData();
    }

    public openDetailHelp(url: string) {
        window.open(url);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getData();
    }

}
